/**
 * Coin flip dialog — shown when both champions have equal Speed at game start.
 * The flip "winner" gets to pick Go First / Go Second.
 *
 * This is rendered inline (not a Radix Dialog) so the look matches the
 * reference screenshot exactly: dark background, centered panel, 2 buttons.
 */
import { Button } from "@/components/ui/Button";

interface CoinFlipDialogProps {
  championSpeed: number; // tied speed value (display only)
  flipWinnerName: string;
  onChoose: (goFirst: boolean) => void;
}

export function CoinFlipDialog({ championSpeed, flipWinnerName, onChoose }: CoinFlipDialogProps) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-sm space-y-4 rounded-xl border border-[#2a2f3a] bg-[#1a1d24] p-6 text-center shadow-2xl">
        <h1 className="font-display text-xl font-bold text-[#e2e8f0]">Coin Flip</h1>
        <p className="text-sm text-[#94a3b8]">
          Both Champions have equal Speed ({championSpeed}). Flip a coin to decide first player.
        </p>
        <p className="text-sm font-semibold text-amber-soft">
          {flipWinnerName} won the flip — choose:
        </p>
        <div className="flex justify-center gap-3">
          <Button onClick={() => onChoose(true)}>Go First</Button>
          <Button variant="secondary" onClick={() => onChoose(false)}>
            Go Second
          </Button>
        </div>
      </div>
    </div>
  );
}
